interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <button
              onClick={() => scrollToSection('home')}
              className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent cursor-pointer"
            >
              ALAMAR S.R.L.
            </button>
          </div>

          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('vpn-service')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              VPN Service
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('legal')}
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
              }`}
            >
              Legal
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block px-6 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-medium hover:shadow-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Get Started
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
